/* eslint-disable no-unused-vars */
/* eslint-disable react/prefer-stateless-function */
// eslint-disable-next-line no-unused-vars

import React, { Component } from 'react';

import { withMsal } from '@azure/msal-react';
import {
  // CircularProgress,
  Stack,
  Button,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  DialogContent,
  DialogActions,
  Box,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import { NoMatch } from 'wae_rwlb_reactlibrary';

import {
  loadSalesOrgData,
  selectSalesOrg,
  handleSalesOrgDialog,
  loadMatrialFilterData,
  getShipToPartyData,
} from './actions/index';
import { AppHeader, PrivateRoute, AppFooter } from './components';
import { history } from './helpers/history';
import {
  Home,
  SystemSelection,
  ProductDetails,
  Upload,
  Order,
  OrderDetails,
  Profile,
  Cart,
  Checkout,
  Confirmation,
  Products,
  Billing,
  Delivery,
  Complaint,
  Favorite,
  Quotation,
  QuotationDetails,
  CreateInquiry,
} from './pages';

class Main extends Component {
  handleChangeSystem = event => {
    const { salesOrgData } = this.props.auth;
    const { value } = event.target;
    const selectedSalesOrgData = salesOrgData.find(d => d.SalesOrg === value);
    this.props.selectSalesOrg(selectedSalesOrgData);
  };

  handleRetry = () => {
    this.props.loadSalesOrgData(this.props.enqueueSnackbar);
  };

  handleDialogClose = () => {
    this.props.handleSalesOrgDialog(false);
    this.props.loadMatrialFilterData(this.props.enqueueSnackbar);
    this.props.getShipToPartyData(this.props.enqueueSnackbar);
  };

  render() {
    const { t, auth } = this.props;
    const { failText, salesOrgData, loggedIn, isOpenSalesOrgDialog, selectedSalesOrgData } = auth;
    // const isAuthPage = window.location.pathname === '/auth';

    return (
      <Stack>
        <BrowserRouter history={history}>
          <AppHeader />
          <Stack sx={{ minHeight: '80vh', pb: 2 }}>
            <Switch>
              <Route exact path="/auth" component={SystemSelection} />
              <PrivateRoute path="/" exact component={Home} />
              <PrivateRoute path="/products/:itemId" exact component={ProductDetails} />
              <PrivateRoute path="/upload" exact component={Upload} />
              <PrivateRoute path="/orders" exact component={Order} />
              <PrivateRoute path="/orders/:orderId" exact component={OrderDetails} />
              <PrivateRoute path="/profile" exact component={Profile} />
              <PrivateRoute path="/cart" exact component={Cart} />
              <PrivateRoute path="/checkout" exact component={Checkout} />
              <PrivateRoute path="/confirmation" exact component={Confirmation} />
              <PrivateRoute path="/products" exact component={Products} />
              <PrivateRoute path="/billing" exact component={Billing} />
              <PrivateRoute path="/delivery" exact component={Delivery} />
              <PrivateRoute path="/favorite" exact component={Favorite} />
              <PrivateRoute path="/complaint" exact component={Complaint} />
              <PrivateRoute path="/quotations" exact component={Quotation} />
              <PrivateRoute path="/quotations/:quotationId" exact component={QuotationDetails} />
              <PrivateRoute path="/createInquiry" exact component={CreateInquiry} />
              <Route component={NoMatch} />
            </Switch>
          </Stack>
          <AppFooter />
        </BrowserRouter>
        <Dialog open={isOpenSalesOrgDialog && loggedIn}>
          <DialogTitle>
            {failText !== '' ? failText : t('mainScreenTranslations:SELECT_SALES_ORG')}
          </DialogTitle>
          <DialogContent>
            {failText === '' ? (
              <Box
                noValidate
                component="form"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  m: 'auto',
                  width: '400px',
                }}
              >
                <FormControl sx={{ mb: 1, mt: 1 }}>
                  <InputLabel>{t('mainScreenTranslations:SELECT_SALES_ORG')}</InputLabel>
                  <Select
                    label={t('mainScreenTranslations:SELECT_SALES_ORG')}
                    value={
                      selectedSalesOrgData.SalesOrg !== undefined
                        ? selectedSalesOrgData.SalesOrg
                        : null
                    }
                    onChange={this.handleChangeSystem}
                  >
                    {salesOrgData.map(item => (
                      <MenuItem key={item.SalesOrg} value={item.SalesOrg}>
                        {`${item.SalesOfficeName} - ${item.SalesOrg}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            ) : null}
          </DialogContent>
          <DialogActions>
            {failText === '' ? (
              <Button
                onClick={this.handleDialogClose}
                disabled={
                  selectedSalesOrgData.SalesOrg === undefined ||
                  selectedSalesOrgData.SalesOrg === ''
                }
                variant="contained"
              >
                {t('mainScreenTranslations:SELECT')}
              </Button>
            ) : (
              <Button onClick={this.handleRetry}> {t('mainScreenTranslations:RETRY')}</Button>
            )}
          </DialogActions>
        </Dialog>
      </Stack>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

const msMain = withMsal(Main);
const sMain = withSnackbar(msMain);

const cMain = connect(mapStateToProps, {
  loadSalesOrgData,
  selectSalesOrg,
  handleSalesOrgDialog,
  loadMatrialFilterData,
  getShipToPartyData,
})(sMain);
const tMain = withTranslation(['mainScreenTranslations'])(cMain);

export { tMain as Main };
